
function SdFilterController() {
    var ctrl = this;


    ctrl.$onInit = function () {
        console.log('$onInit');

        ctrl.loaded = false;
        ctrl.status = 'Aguardando';       
    };

    ctrl.filterClicked = function (filter) {
        console.log('filterClicked ' + filter.name);
    };

    ctrl.doSelectOption = function (option) {
        if (option) {
            ctrl.onSelectOption({
                option: option
            });
        }
    };

    ctrl.filterOption = function (filter1, label) {
        var filter = ctrl.findFilter(label);
        if (filter) {
            ctrl.isOpen = false;
        }

        ctrl.doSelectOption(label);
    };

    ctrl.activeCount = function () {
        var count = 0;
        if (ctrl.filters) {
            for (var i = 0; i < ctrl.filters.length; i++) {
                var filter = ctrl.filters[i];
                if (ctrl.hasFilter(filter) || filter.changed) {
                    count++;
                }
            }
        }        
        return count;
    };

    ctrl.hasFilter = function (filter) {
        if (!filter) {
            return false;
        }

        if (!filter.selected) {
            return false;
        }
        return filter.selected.length > 0;
    };

    ctrl.findFilter = function (label) {
        for (var i = 0; i < ctrl.filters.length; i++) {
            if (ctrl.filters[i].label === label) {
                return ctrl.filters[i];
            }
        }
        return null;
    };

    

    ctrl.doClear = function() {
        if (ctrl.filters) {
            for (var i = 0; i < ctrl.filters.length; i++) {
                var filter = ctrl.filters[i];
                filter.value = filter.defaultValue;                               
                filter.changed = false;
                filter.selected = [];
            }
            ctrl.doSelectOption(ctrl.filters);
        }
        
        ctrl.isOpen = false;
    };

    ctrl.toggleFilter = function (filter, event) {
        if (filter.changed) {
            filter.changed = false;
        }
        else {
            filter.included = true;
            filter.changed = true;
            filter.isOpen = true;

            console.log('toggleFilter: ' + filter.isOpen);

            console.log(filter);

            event.stopPropagation();
        }        
    };

    ctrl.doSearch = function () {
        console.log('doSearch');

        ctrl.doSelectOption(ctrl.filters);

        ctrl.isOpen = false;
    };

    ctrl.doCancel = function () {
        console.log('doCancel');
        ctrl.isOpen = false;
    };
}

seedWebApp.component('sdFilterPanel', {
    controller: SdFilterController,
    bindings: {
        label: '<',        
        filters: '<',
        isOpen: '=',
        isLoading: '=',
        onLoadFilters: '&',
        onSelectOption: '&'
    },
    templateUrl: '/SPA/components/filters/sd-filter-panel.html'
});